(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dag-product-family"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('dag-family'))customElements.define('dag-family',class extends HTMLElement{
connectedCallback(){
 if(this.initialized)return;this.initialized=true;
 this.options=[...this.querySelector('[data-family-options]').options];if(!this.options.length)return;
 this.selects=[...this.querySelectorAll('select[data-dimension]')];
 const current=(this.dataset.mode==='product'?this.options.find(o=>o.dataset.product===this.dataset.current):this.options.find(o=>o.dataset.available==='true'))||this.options[0];
 this.selects.forEach(s=>{s.dataset.preferred=current.dataset[s.dataset.dimension]||'';s.addEventListener('change',()=>{this.sync();if(this.dataset.mode==='product'&&this.selected.dataset.product!==this.dataset.current)window.location.assign(this.selected.dataset.url);});});
 this.sync(true);this.querySelector('.dag-family-controls').hidden=false;
 const button=this.querySelector('button');if(button)button.hidden=false;
}
sync(initial=false){
 let candidates=this.options;
 for(const select of this.selects){
  const key=select.dataset.dimension,previous=initial?select.dataset.preferred:select.value;
  const values=[...new Set(candidates.map(o=>o.dataset[key]||''))];
  if(key==='size'){const order=['XXS','XS','S','S/M','M','M/L','L','L/XL','XL','2XL','3XL','4XL'];const aliases={'SMALL':'S','MEDIUM':'M','LARGE':'L','XXL':'2XL','XXXL':'3XL','EXTRA SMALL':'XS','EXTRA LARGE':'XL'};const rank=v=>order.indexOf(aliases[v.trim().toUpperCase()]||v.trim().toUpperCase());values.sort((a,b)=>{const x=rank(a),y=rank(b);if(x>=0&&y>=0)return x-y;if(x>=0)return -1;if(y>=0)return 1;return a.localeCompare(b,undefined,{numeric:true});});}
  select.replaceChildren(...values.map(v=>new Option(v,v)));if(values.includes(previous))select.value=previous;
  select.closest('label').hidden=values.every(v=>!v);
  candidates=candidates.filter(o=>(o.dataset[key]||'')===select.value);
 }
 this.selected=candidates[0];if(!this.selected)return;const d=this.selected.dataset;
 const id=this.querySelector('input[name="id"]');if(id)id.value=this.selected.value;
 this.querySelector('[data-price]').textContent=d.price;this.querySelector('span[data-sku]').textContent=d.sku;
 this.querySelectorAll('[data-detail]').forEach(a=>a.href=d.url);
 const img=this.querySelector('img');if(img&&d.image){img.removeAttribute('srcset');img.src=d.image;img.alt=this.selected.textContent;}
 const stock=this.querySelector('[data-stock]');stock.textContent=d.available==='true'?stock.dataset.ready:stock.dataset.sold;
 const button=this.querySelector('button');if(button)button.disabled=d.available!=='true';
}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["popup_modal_size_chart"] && !Shopify.designMode) return;
  try {
    function setupDagSizeGuide() {
 const guide = document.getElementById('dag-size-guide');
 const links = document.querySelectorAll('.size-chart-open-popup');
 links.forEach(link => {
   link.hidden = !guide || guide.dataset.available !== 'true';
   link.setAttribute('role','button');
   link.setAttribute('aria-haspopup','dialog');
   link.setAttribute('aria-controls','dag-size-guide');
   link.removeAttribute('aria-label');
   link.removeAttribute('data-toggle');
   link.removeAttribute('data-target');
 });
 if (!guide || guide.dataset.bound) return;
 guide.dataset.bound = 'true';
 let opener;
 document.addEventListener('click', event => {
   const trigger = event.target.closest('.size-chart-open-popup');
   if (!trigger || trigger.hidden) return;
   event.preventDefault();
   event.stopImmediatePropagation();
   opener = trigger;
   if (!guide.open) guide.showModal();
 }, true);
 links.forEach(link => link.addEventListener('keydown', event => {
   if(event.key === ' ') {event.preventDefault();link.click();}
 }));
 guide.querySelectorAll('.dag-size-close,.dag-size-done').forEach(button => button.addEventListener('click',()=>guide.close()));
 guide.addEventListener('click', event => {
   if(event.target !== guide) return;
   const rect=guide.getBoundingClientRect();
   if(event.clientX<rect.left || event.clientX>rect.right || event.clientY<rect.top || event.clientY>rect.bottom) guide.close();
 });
 guide.addEventListener('close',()=>opener?.focus());
}
if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',setupDagSizeGuide); else setupDagSizeGuide();
document.addEventListener('shopify:section:load',setupDagSizeGuide);
  } catch(e) { console.error(e); }
})();

})();
